/**
 * @generated SignedSource<<042b163c8b54cd6869d947cc86960470>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
export type ConnectAdminCreateInitQuery$variables = Record<PropertyKey, never>;
export type ConnectAdminCreateInitQuery$data = {
  readonly store: {
    readonly todoCategories: ReadonlyArray<{
      readonly icon: TodoCategoryIcon | null;
      readonly id: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"ConnectAdminCreateInit_item">;
    }>;
  };
};
export type ConnectAdminCreateInitQuery = {
  response: ConnectAdminCreateInitQuery$data;
  variables: ConnectAdminCreateInitQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "includeDefault",
    "value": true
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConnectAdminCreateInitQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v0/*: any*/),
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategories",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ConnectAdminCreateInit_item"
              }
            ],
            "storageKey": "todoCategories(includeDefault:true)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ConnectAdminCreateInitQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v0/*: any*/),
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategories",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": "todoCategories(includeDefault:true)"
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "48ff1dadedf1fc8085f4f507eaa5cf7e",
    "id": null,
    "metadata": {},
    "name": "ConnectAdminCreateInitQuery",
    "operationKind": "query",
    "text": "query ConnectAdminCreateInitQuery {\n  store {\n    todoCategories(includeDefault: true) {\n      id\n      title\n      icon\n      ...ConnectAdminCreateInit_item\n    }\n    id\n  }\n}\n\nfragment ConnectAdminCreateInit_item on TodoCategory {\n  id\n  title\n  icon\n}\n"
  }
};
})();

(node as any).hash = "70aea8cdab76610254baa31558d7f5c8";

export default node;
